// Un destino de AnyDesk puede ser DOS cosas distintas:
//   - un ID numérico, que casi siempre guardamos agrupado para leerlo: "1 345 070 305"
//   - un ALIAS, que es texto: "beltro-bera@ad" (Papelera lo usa en la MACCHINA)
//
// El formato agrupado es para mostrar, no para lanzar: va como un solo argv a AnyDesk.exe y
// como URI en el fallback `anydesk:<destino>`, donde el espacio lo rompe. Pero pelar todo lo
// que no sea dígito destruiría el alias, que es un destino perfectamente válido.
//
// Regla: si el valor es sólo dígitos y separadores, se le sacan los separadores. Si no, es un
// alias y se manda tal cual (nada más que trim).
export function anydeskTarget(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return /^[\d\s.\-()]+$/.test(raw) ? raw.replace(/\D+/g, '') : raw;
}

export default anydeskTarget;
